import { bootstrapPortal } from "@/shared/app/bootstrapPortal";
import AdminApp from "./App.admin";

bootstrapPortal("admin", <AdminApp />);
